import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  isSlowScrolling as isSlowScrollingSelector, 
  isAutoScrollEnabledByDefault as isAutoScrollEnabledByDefaultSelector
} from '../../selectors/configSelectors';
import KioskAutoScroll from '../../components/KioskAutoScroll';
import { reset } from '../../actions/product';
import { isMainPageOpen } from '../../selectors/router_selector';

class ConfigInitialized extends Component {
  state = {
    isFetched: false
  };

  shouldComponentUpdate(nextProps) {
    if (!nextProps.config) {
      return false
    }
    return (
      this.state.isFetched !== nextProps.config.configFetched ||
      this.props.maintenance !== nextProps.maintenance
    );
  }

  render() {
    const {isSlowScrolling, configFetched, isAutoScrollEnabledByDefault} = this.props;
    return (
      <div>
        {configFetched && 
          <div>
            {isSlowScrolling && <KioskAutoScroll startScroll={isAutoScrollEnabledByDefault}/>}
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSlowScrolling: isSlowScrollingSelector(state),
    configFetched: state.config.configFetched,
    isAutoScrollEnabledByDefault: isAutoScrollEnabledByDefaultSelector(state),
    isMainPage: isMainPageOpen(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: () => dispatch(reset()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigInitialized);



// WEBPACK FOOTER //
// ./src/components/ConfigInitialized/ConfigInitialized.jsx